import React from "react";
import { useTheme } from "../../context/ThemeContext";

const PartnerLogos: React.FC = () => {
  const { theme } = useTheme();

  return (
    <div className="bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-2">
          <div className="flex justify-start">
            {" "}
            <div className="flex-shrink-0">
              <img
                src={
                  theme === "light"
                    ? "/autofront_light.png"
                    : "/autofront_dark.png"
                }
                alt="Partner Logo"
                className="h-8 w-auto opacity-80 hover:opacity-100 transition-opacity duration-200"
                loading="lazy"
                decoding="async"
                width="120"
                height="32"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnerLogos;
